export default __webpack_public_path__ + "static/media/BeamsImg.6c5c1661.jpg";